import React from 'react';
import { prop } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';

import { GamesView } from '.';
import { DISPLAY_MODE, GAME_SIZES } from './constants';

export const SLIDER_OPTIONS_MINI = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};

export const GamesViewMini = (props) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return (
        <GamesView
            displayMode={isDesktop ? DISPLAY_MODE.PAGING : DISPLAY_MODE.SLIDER}
            gameSize={GAME_SIZES.EXTRA_SMALL}
            sliderOptions={SLIDER_OPTIONS_MINI}
            fillLastSlide={false}
            gamesPerSlideMin={1}
            showFeatureIcons={false}
            {...props}
        />
    );
};

export default GamesViewMini;
